/**
 * Populate List
 * @param {targetEl} param0 the HTML to inject the listinto
 * @param {template} function returning string literal to be used for each list item
 * @param {endpoint} the endpoint with an array of object to use for each list itme
 * 
 * Use example: 
 * 
 *  populateList({
 *       targetEl : document.getElementById('posts'),
 *       template : (post) => `<li>${post.name}</li>`,
 *       endpoint : 'https://mysite.com/api/v2/posts'
 *  });
 */

function populateList({targetEl, template, endpoint, exclude}){

    fetch(endpoint) 
    .then((resp) => resp.json())
    .then(data => {
        data.map(item => {

            if(exclude == 'Uncategorized') return;

            targetEl.innerHTML += template(item);

        });
    })   
};

window.populateList = populateList;

